module.exports = __webpack_public_path__ + "img/image18.0478cd1e.png";